var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9532",
    "data-name": "Group 9532",
    transform: "translate(-802 -262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3196",
    "data-name": "Rectangle 3196",
    width: 73,
    height: 73,
    rx: 10,
    transform: "translate(802 262)",
    fill: "#4791ff",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841",
    transform: "translate(821.02 276.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M74.6,248.556a11.938,11.938,0,0,0-.036-1.238A3.785,3.785,0,0,0,72.1,244.08a3.89,3.89,0,0,0-1.27-.235c-.1,0-.192,0-.292,0s-.185,0-.278,0c-1.231-.014-2.466,0-3.7,0-.231,0-.463-.032-.74-.057a3.15,3.15,0,0,0-2.092-3.548H50l-.053.021a3.151,3.151,0,0,0-2.035,3.523c-.306.021-.559.06-.811.06-1.2.007-2.409-.011-3.612,0-.093,0-.185,0-.278,0-.132,0-.263,0-.395,0a3.88,3.88,0,0,0-2.057.623l-.1.064a3.234,3.234,0,0,0-1.2,1.409c-.018.036-.036.075-.053.11s-.032.082-.05.125a3.989,3.989,0,0,0-.288,1.142l-.011.139c-.032.363-.028.729-.028,1.1q-.005,11.609,0,23.225v6.48a8.163,8.163,0,0,0,.242,2.284c.367,1.21,1.2,1.854,2.914,2.576H71.46c1.637-.69,2.466-1.313,2.85-2.427a7.529,7.529,0,0,0,.292-2.434V270.87Q74.6,259.71,74.6,248.556Zm-23-4.7H62.084v3.473H51.6ZM71.09,278.642c-.007.715-.235.918-.964.911-3.786-.021-7.572-.018-11.358-.018H54.943c-3.807,0-7.611,0-11.419.018-.751.007-.971-.206-.968-.968v-.011q.016-6.181.018-12.365.005-8.962-.014-17.923a2.236,2.236,0,0,1,.025-.363v-.007a.593.593,0,0,1,.548-.573h1.174a.086.086,0,0,1,.043,0c.907.007,1.822,0,2.758,0h.786c.011.085.018.171.021.249a7.4,7.4,0,0,0,.011.808,2.706,2.706,0,0,0,1.341,2.167c.057.032.114.064.171.089a1.765,1.765,0,0,0,.171.075c.078.032.157.057.238.082a2,2,0,0,0,.253.057c.085.018.174.028.263.039s.178.011.27.011q6.213.021,12.433,0h.028a2.677,2.677,0,0,0,2.719-2.519c.028-.31,0-.626,0-1.057h.729c.936,0,1.85.011,2.761,0a.1.1,0,0,1,.046,0H70.51c.466.071.576.377.576.943q-.011,6.949-.014,13.9v3.96q0,1.345,0,2.687,0,2.2,0,4.4.005,2.679.011,5.355Z",
    transform: "translate(-39.03 -240.23)",
    fill: "#4791ff",
    stroke: "#e0ecfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M73.165,302.511a1.931,1.931,0,0,1-2.106,2.046c-1.023.008-2.042.012-3.064.012-2.238.008-4.476,0-6.71-.012a1.969,1.969,0,0,1-2.146-2.017,1.872,1.872,0,0,1,1.516-1.845,2.915,2.915,0,0,1,.61-.072c1.648-.02,3.3-.008,4.941-.008,1.612,0,3.221-.012,4.833,0C72.375,300.638,73.137,301.331,73.165,302.511Z",
    transform: "translate(-52.473 -279.368)",
    fill: "#4791ff",
    stroke: "#e0ecfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M101.266,282.387c.012,1.251-.794,2-2.242,2.025-1.251.024-2.5,0-3.754,0s-2.5.02-3.758,0a2.025,2.025,0,1,1,.052-4.011q3.7-.024,7.4,0C100.4,280.41,101.25,281.172,101.266,282.387Z",
    transform: "translate(-72.341 -266.265)",
    fill: "#4791ff",
    stroke: "#e0ecfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M66.2,322.615a2.022,2.022,0,0,1-2.074,1.965q-.126.012-.253.012c-1.251.012-2.507,0-3.754,0s-2.507.016-3.758,0a1.952,1.952,0,0,1-2.19-1.969,2,2,0,0,1,2.242-2.037q3.327-.024,6.658,0c.285,0,.57,0,.854,0A2.056,2.056,0,0,1,66.2,322.615Z",
    transform: "translate(-47.241 -292.285)",
    fill: "#4791ff",
    stroke: "#e0ecfe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M67.125,282.338a1.9,1.9,0,0,1-1.889,2.042c-.269.02-.533.028-.8.028-.176,0-.353,0-.529-.008-.04,0-.08,0-.116,0-.14,0-.273,0-.413,0-.044,0-.092,0-.14,0H63.09c-.1,0-.209,0-.313,0-.156,0-.313,0-.469.008-.289.008-.574.008-.862,0-.128,0-.261-.012-.393-.02a1.969,1.969,0,0,1-1.913-2.042,1.942,1.942,0,0,1,1.909-1.937c1.392-.064,2.792-.06,4.183,0A1.916,1.916,0,0,1,67.125,282.338Z",
    transform: "translate(-52.21 -266.243)",
    fill: "#4791ff",
    stroke: "#e0ecfe",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTasks);
export default __webpack_public_path__ + "static/media/totalTasks.8c571910153f7ebca4d7d6ca14007ad5.svg";
export { ForwardRef as ReactComponent };